export const patientLookupJA  = {
    "Breast and Ovarian Cancer Screening Questionnaire": "Breast and Ovarian Cancer Screening Questionnaire",
    "Patient Lookup": "Patient Lookup",
    "Enter Your": "Enter Your",
    "Search": "Search",
    "No results found": "No results found",
    "No results found message": "No results found. Please notify the staff",
    "Close": "Close",
    "selectStepInstructions": "Please select the correct first three letters of your first and last name. If you do not see yourself, please notify the staff.",
    "Back": "Back",
    "Confirm": "Confirm",
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Incorrect Date of Birth": "Incorrect Date of Birth. Please try again or notify the staff",
    "Please Enter Your": "Please Enter Your",
    "Cancel": "Cancel",
    "dob_validation_failed": "Incorrect Date of Birth",
    "dob_validation_failed_msg": "Incorrect Date of Birth. Please try again or notify the staff.",
    "Clear": "Clear",
    "Confirmation Message": "Confirmation Message",
    "MRN not found": "not found in records. Please confirm if entered correctly.",
    "Unable to create new pedigree": "Unable to create new pedigree",
    "Unable to create new pedigree message": "Unable to create new pedigree. Please notify the staff",
    "Values dont match": "Values don't match",
    "Entered": "Entered",
    "is not matching firstly entered": "is not matching firstly entered",
    "session_timeout": "Session Timeout",
    "session_timeout_msg": "Your session has expired. Press a button to reload the page.",
    "reload": "Reload",
    "Not Available": "Not Available"
};